import authService from '@/services/auth-service'
import { underLoadingFunction } from '@/store/helpers/under-loading'
import * as MutationTypes from './mutation-types'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import { UserBlockedError } from '../../models/user-blocked-error'

export default {
  state: {
    feedbackAuth: false,
    loadingAuth: false,
    perfis: [],
    isLogged: undefined,
    listAllContacts: null
  },

  getters: {
    feedbackAuth: (state) => {
      return state.feedbackAuth
    },
    loadingAuth: (state) => {
      return state.loadingAuth
    },
    perfis: (state) => state.perfis,
    allContacts: (state) => state.listAllContacts,
    getIsLogged(state) {
      return state.isLogged
    }
  },

  mutations: {
    [MutationTypes.SET_FEEDBACK_AUTH](state, show) {
      state.feedbackAuth = show
    },
    [MutationTypes.SET_LOADING](state, loading) {
      state.loadingAuth = loading
    },
    [MutationTypes.SET_PERFIS](state, value) {
      state.perfis = value
    },
    [MutationTypes.SET_IS_LOGGED](state, payload) {
      state.isLogged = payload
    },
    [MutationTypes.LIST_CONTACTS](state, payload) {
      state.listAllContacts = payload
    },
    [MutationTypes.SET_CURRENT_USER](state, payload) {
      state.listAllContacts = payload
    }
  },

  actions: {
    async auth({ commit }, payload) {
      return authService
        .login(payload)
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()
            if (res.status === 409) throw new UserBlockedError()
            return res.json()
          }
          commit(MutationTypes.SET_IS_LOGGED, true)
        })
        .then((data) => {
          return data
        })
    },
    async getPerfis({ commit }) {
      await authService
        .getPerfis()
        .then((res) => {
          if (!res.ok) {
            return {}
          }
          return res.json()
        })
        .then((data) => {
          return commit(MutationTypes.SET_PERFIS, data)
        })
    },
    async getContatos({ commit }, login) {
      return authService.getContatos(login).then((response) => {
        return response.json()
      })
    },
    async setLogged({ commit }, payload) {
      commit(MutationTypes.SET_IS_LOGGED, payload)
    },
    listContactsAction: underLoadingFunction(async ({ commit }, payload) => {
      await authService
        .listContact(payload)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.LIST_CONTACTS, data)
        })
        .catch((err) => {
          throw err
        })
    }),
    async recuperarSenha({ commit }, payload) {
      await authService
        .recuperarSenha({ ...payload })
        .then((res) => {
          if (!res.ok) {
            return res.json()
          }
        })
        .then((data) => {
          if (data && data.status === 500) {
            throw new Error(data.detail)
          }
        })
    },
    async atualizarSenha({ commit }, payload) {
      await authService.atualizarSenha(payload).then(async (res) => {
        if (!res.ok) {
          if (res.status === 401) throw new NotAuthenticatedError()
          let erros = await res.json()
          throw erros
        }
        return res.status
      })
    },
    async redefinirSenha({ commit }, payload) {
      await authService
        .redefinirSenha(payload)
        .then(async (res) => {
          if (!res.ok) {
            let erros = await res.json()
            throw erros
          }
          return res.status
        })
        .catch((err) => {
          throw err
        })
    },
    alterarSenha: underLoadingFunction(async ({ commit }, payload) => {
      await authService
        .alterarSenha(payload)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.status
        })
        .catch((err) => {
          throw err
        })
    }),
    recuperarRegistro: underLoadingFunction(async ({ commit }, payload) => {
      let resul = await authService
        .recuperarRegistro(payload.emailTelefone, payload.cpf)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.status
        })
        .catch((err) => {
          throw err
        })

      return resul
    }),
    contatosCpf: underLoadingFunction(async ({ commit }, payload) =>
      authService
        .contatosCpf(payload)
        .then(async (res) => {
          if (!res.ok) {
            throw new Error(`HTTP error, status ${res.status}`)
          }
          let c = await res.json()
          return c
        })
        .catch((err) => {
          throw err
        })
    )
  }
}
